import MessageApi from '../../../../api/inbox/message';

export default {
  // No local mutation: the backend writes the reaction onto the message's content_attributes and the
  // existing message.updated broadcast brings it back, the same way a reaction made on a phone arrives.
  async reactToMessage(_, { conversationId, messageId, emoji }) {
    await MessageApi.react(conversationId, messageId, emoji);
  },
};
